import { onMessage } from "firebase/messaging";
import { initFirebase } from "./firebase";

export const setupForegroundNotification = async () => {
    try {
        const { messaging } = await initFirebase();
        
        if (!messaging) return;

        onMessage(messaging, (payload) => {
            // Ensure the browser supports Service Workers before trying to use them
            if ("serviceWorker" in navigator) {
                navigator.serviceWorker.ready.then((registration) => {
                    // Route the notification through the Service Worker to avoid the crash
                    registration.showNotification(payload.data.title, {
                        body: payload.data.body,
                        icon: "/App-icon.svg"
                    });
                });
            }
        });
    } catch (error) {
        console.error("Foreground notification setup failed:", error);
    }
};